import { Component, OnInit } from '@angular/core';
import { MapConstants } from 'src/app/utils/map.constant';
import { ProjConstants } from 'src/app/utils/proj.constant';
import { isNullOrUndefined } from 'util';

import { HeatwaveMapConstants } from './utils/constant/heatwave-map.constat';
import { MapService } from './utils/service/map.service';

@Component({
  selector: 'app-heat-wave',
  templateUrl: './heat-wave.component.html',
  styleUrls: ['./heat-wave.component.scss']
})
export class HeatWaveComponent implements OnInit {

  stateName: any;
  layerList: any;
  otherOptions: {};
  initializeBool = true;
  stateId = 'akbm';

  constructor(
  ) {
    this.stateName = ProjConstants.IDTOSTATENAMEMAPPING[this.stateId];
  }

  ngOnInit() {
    this.getLayersList();
    this.getOtherOptions();
  }

  getLayersList() {
    let layerList = [];
    layerList = layerList.concat(this.getCommonLayers());
    this.layerList = layerList;
  }

  getCommonLayers() {
    const layerList: any = HeatwaveMapConstants.CommonLayers;
    for (const i in layerList) {
      if (!isNullOrUndefined(i)) {
        const layer = layerList[i];
        layer['stateName'] = this.stateName;
        if (layer.layerNameType) {
          if (layer['serviceType'] === 'VectorLayer') {
            layer['layerName'] = ProjConstants.STATE_TO_LAYERTYPE_NAME[this.stateName + '_' + layer.layerNameType];
          } else {
            layer['layerName'] = MapConstants.GEOSERVER_WORKSPACE_NAME + ':' + ProjConstants.STATE_TO_LAYERTYPE_NAME[this.stateName + '_' + layer.layerNameType];
          }
        }
        if (layer.serviceType === 'VectorLayer') {
          const today = new Date();
          const startTs = today.getTime()
          const endTs = today.getTime() + (6 * 24 * 60 * 60 * 1000);
          layer['postData'] = {
            component : 'HEATWAVE',
            sUUID : ProjConstants.IDTOUUIDMAPPING[this.stateId],
            pUUID : ProjConstants.IDTOUUIDMAPPING[this.stateId],
            pType : 'COUNTRY',
            cType : 'DISTRICT',
            startTs: startTs,
            endTs: endTs
          };
        }
      }
    }
    return layerList;
  }

  getOtherOptions() {
    const otherOptions = {};
    otherOptions['legend'] = HeatwaveMapConstants.Legend;
    otherOptions['service'] = MapService;
    this.otherOptions = otherOptions;
  }
}
